import {
	Button,
	Card,
	CardActions,
	CardContent,
	Collapse,
	Divider,
	styled,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface CollapsibleCardProps {
	className?: string;
	expanded: boolean;
	content: React.ReactNode;
	collapsibleContent: React.ReactNode;
	collapsibleDivider?: boolean;
	moreContent?: React.ReactNode;
}

function CollapsibleCard(props: CollapsibleCardProps) {
	return (
		<Card className={props.className}>
			<CardContent>{props.content}</CardContent>
			{props.collapsibleDivider && props.expanded && (
				<Divider orientation="horizontal" flexItem sx={{ my: 1 }}></Divider>
			)}

			<Collapse in={props.expanded} timeout="auto" unmountOnExit>
				<CardContent>{props.collapsibleContent}</CardContent>
			</Collapse>
			{props.moreContent && <CardContent>{props.moreContent}</CardContent>}
		</Card>
	);
}

export { CollapsibleCard };
